import httpClient from './httpClient'

// Both endpoints live in ExchangeAnalyticsService, which serves under the
// /api/v1/exchange-analytics ingress — hence the /exchange-analytics prefix on the
// default http client (the bare /api/v1/reporting/... prefix belongs to
// ReportingService). Wiring guide: docs/MARKET_CONTEXT_WIRING.md
const END_POINT = '/exchange-analytics/buyer'

const MarketContextAPI = {
  // One row per campaign, whatever its routing type, positioned against its market cell's
  // winning-bid distribution over a TRAILING WINDOW WHOSE LENGTH VARIES: 24 hours on six
  // days of the week, 168 hours on Mondays (America/Los_Angeles), because a Monday 24h
  // window looks back at Sunday and the weekend volume dip makes those percentiles swing.
  // The {rows, truncated, limit, windowHours} envelope reports the length actually used, and
  // it is present even when rows is empty - never assume 24. Every count and percentile on
  // every row is measured over it, which is why the same campaign can carry a different
  // tier, rank and missed-call count on Monday than on Tuesday.
  //
  // Three row states, told apart by positionedBidInUSD: a Static campaign positioned on its
  // configured max bid; an RTB/Programmatic campaign positioned on the median bid observed
  // over the window; and a dynamic campaign that placed no bids in the window, whose market
  // half (percentiles, marketActivity) is populated while positionedBidInUSD, tier, rankBand,
  // suggestedBidInUSD and estimatedAdditionalCallsPerDay are all null - null rather than
  // zero, because it did not bid at all. WHICH of the last two states a dynamic campaign
  // lands in can itself change with the window: one that bid five days ago but is paused
  // today is positioned on Mondays and bid-less on Tuesdays.
  //
  // A campaign is omitted only when its market cell had no auctions in the window - so a
  // thin cell with auctions last week but none yesterday is omitted on the short window and
  // present on the long one. A positioned campaign that merely didn't bid still gets a full
  // row with zeroed missed/estimate fields.
  async getCampaignMarketPositions(accountId) {
    return httpClient.get(`${END_POINT}/${accountId}/campaigns/market-positions`)
  },

  // 7d market context for one category, optionally narrowed by country/language
  // (omitted = aggregate across). Bare object (no envelope). An empty market cell
  // returns null percentiles, tiers: [] and winRateCurve: null — the panel stays hidden.
  async getCategoryMarketContext(accountId, { categoryId, countryId, languageId }) {
    return httpClient.get(`${END_POINT}/${accountId}/market-context`, {
      params: { categoryId, countryId, languageId }
    })
  }
}

export default MarketContextAPI
